import script from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=bfe765ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfe765ba"]])

export default __exports__